/* HILUNA theme script — no dependencies. */
(() => {
  'use strict';

  const HL = window.HL = Object.assign({
    routes: { cart: '/cart', cart_add: '/cart/add', cart_change: '/cart/change', cart_update: '/cart/update', search: '/search', predictive: '/search/suggest' },
    currency: 'ILS',
    freeShipping: 39900,
    giftWrap: null,
    greetKey: 'ברכה אישית למתנה'
  }, window.HL || {});

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fmt = new Intl.NumberFormat('he-IL', { style: 'currency', currency: HL.currency, minimumFractionDigits: 0, maximumFractionDigits: 2 });
  const money = (cents) => fmt.format((cents || 0) / 100);
  HL.money = money;
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const debounce = (fn, ms) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };
  const imgUrl = (url, w) => {
    if (!url) return '';
    if (!/cdn\.shopify|\/cdn\/shop\//.test(url)) return url;
    return url + (url.includes('?') ? '&' : '?') + 'width=' + w;
  };
  const ICON = {
    minus: '<svg viewBox="0 0 12 12" class="icon"><path d="M2 6h8"/></svg>',
    plus: '<svg viewBox="0 0 12 12" class="icon"><path d="M2 6h8M6 2v8"/></svg>',
    arrow: '<svg viewBox="0 0 24 24" class="icon"><path d="M19 12H5M11 6l-6 6 6 6"/></svg>',
    bag: '<svg viewBox="0 0 24 24" class="icon"><path d="M5 8h14l-1 12H6L5 8z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>'
  };

  document.documentElement.classList.add('js');

  /* ---------------- toast ---------------- */
  let toastT;
  function toast(msg) {
    let el = $('.toast');
    if (!el) { el = document.createElement('div'); el.className = 'toast'; el.setAttribute('role', 'status'); document.body.appendChild(el); }
    el.textContent = msg;
    el.classList.add('is-on');
    clearTimeout(toastT);
    toastT = setTimeout(() => el.classList.remove('is-on'), 2600);
  }

  /* ---------------- drawers (cart, menu, search) ---------------- */
  const overlay = $('.overlay');
  let openDrawer = null;
  let lastFocus = null;

  function trapFocus(e) {
    if (!openDrawer || e.key !== 'Tab') return;
    const f = $$('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), textarea, select, [tabindex]:not([tabindex="-1"])', openDrawer)
      .filter((el) => el.offsetParent !== null || el === document.activeElement);
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function open(id) {
    const el = document.getElementById(id);
    if (!el) return;
    if (openDrawer && openDrawer !== el) close(false);
    lastFocus = document.activeElement;
    openDrawer = el;
    el.classList.add('is-open');
    el.removeAttribute('aria-hidden');
    overlay && overlay.classList.add('is-open');
    document.body.classList.add('is-locked');
    $$(`[aria-controls="${id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'true'));
    const target = $('[data-autofocus]', el) || $('.drawer__head button, button, a', el);
    setTimeout(() => target && target.focus({ preventScroll: true }), 60);
  }

  function close(restore = true) {
    if (!openDrawer) return;
    const id = openDrawer.id;
    openDrawer.classList.remove('is-open');
    openDrawer.setAttribute('aria-hidden', 'true');
    $$(`[aria-controls="${id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
    openDrawer = null;
    overlay && overlay.classList.remove('is-open');
    document.body.classList.remove('is-locked');
    if (restore && lastFocus) lastFocus.focus({ preventScroll: true });
  }
  HL.open = open; HL.close = close;

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) { e.preventDefault(); open(opener.dataset.open); return; }
    if (e.target.closest('[data-close]') || e.target === overlay) close();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { close(); closeMegas(); }
    trapFocus(e);
  });

  /* ---------------- announcement ---------------- */
  (() => {
    const msgs = $$('.announce__msg');
    if (msgs.length < 2 || reduced) return;
    let i = 0;
    setInterval(() => {
      if (document.hidden) return;
      const cur = msgs[i];
      cur.classList.add('is-leaving');
      cur.classList.remove('is-active');
      setTimeout(() => cur.classList.remove('is-leaving'), 500);
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, 4800);
  })();

  /* ---------------- header ---------------- */
  const header = $('.header');
  function closeMegas(except) {
    $$('.has-mega.is-open').forEach((li) => {
      if (li === except) return;
      li.classList.remove('is-open');
      const b = $('.nav-trigger', li); b && b.setAttribute('aria-expanded', 'false');
    });
  }
  if (header) {
    const wrap = header.closest('.section-header') || header;
    let lastY = window.scrollY;
    let ticking = false;
    const onScroll = () => {
      const y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 10);
      const goingDown = y > lastY + 2 && y > 320;
      const goingUp = y < lastY - 2;
      if (!openDrawer && !$('.has-mega.is-open') && (goingDown || goingUp || y < 320)) {
        wrap.classList.toggle('is-hidden', goingDown);
        document.body.classList.toggle('header-hidden', goingDown);
      }
      lastY = y;
      ticking = false;
    };
    window.addEventListener('scroll', () => { if (!ticking) { requestAnimationFrame(onScroll); ticking = true; } }, { passive: true });
    onScroll();

    $$('.has-mega').forEach((li) => {
      const btn = $('.nav-trigger', li);
      let t;
      const show = () => { clearTimeout(t); closeMegas(li); li.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); };
      const hide = () => { t = setTimeout(() => { li.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }, 160); };
      btn.addEventListener('click', () => (li.classList.contains('is-open') ? hide() : show()));
      if (window.matchMedia('(hover: hover)').matches) {
        li.addEventListener('mouseenter', show);
        li.addEventListener('mouseleave', hide);
      }
      li.addEventListener('focusout', (e) => { if (!li.contains(e.relatedTarget)) hide(); });
    });
  }

  /* ---------------- video opening ---------------- */
  (() => {
    const hero = $('[data-vhero]');
    if (!hero) return;
    if (header && header.classList.contains('is-over-hero')) header.classList.add('is-over-dark');
    requestAnimationFrame(() => hero.classList.add('is-in'));
    const videos = $$('video', hero);
    if (!videos.length) return;
    const btn = $('[data-vhero-toggle]', hero);
    const visible = () => videos.find((v) => v.offsetParent !== null) || videos[0];
    let userPaused = reduced;
    const play = () => {
      const v = visible();
      videos.forEach((x) => { if (x !== v) x.pause(); });
      v.muted = true; v.playsInline = true; v.loop = true;
      const p = v.play();
      if (p && p.catch) p.catch(() => hero.classList.add('is-paused'));
    };
    const pause = () => videos.forEach((v) => v.pause());
    videos.forEach((v) => {
      v.addEventListener('playing', () => { hero.classList.add('is-playing'); hero.classList.remove('is-paused'); });
      v.addEventListener('pause', () => hero.classList.add('is-paused'));
    });
    btn && btn.addEventListener('click', () => {
      userPaused = !hero.classList.contains('is-paused') ? true : false;
      if (userPaused) pause(); else play();
      btn.setAttribute('aria-label', userPaused ? 'הפעלת הסרטון' : 'השהיית הסרטון');
    });
    if (userPaused) { hero.classList.add('is-paused'); if (btn) btn.setAttribute('aria-label', 'הפעלת הסרטון'); }
    // play only while on screen, to save battery and data
    new IntersectionObserver(([en]) => { if (userPaused) return; en.isIntersecting ? play() : pause(); }, { threshold: .15 }).observe(hero);
    window.addEventListener('resize', debounce(() => { if (!userPaused) play(); }, 300));
  })();

  /* ---------------- hero slider ---------------- */
  (() => {
    const hero = $('[data-hero]');
    if (!hero) return;
    const slides = $$('.hero__slide', hero);
    const titles = $$('.hero__title', hero);
    const subs = $$('.hero__sub', hero);
    const bars = $$('.hero__bar', hero);
    const countEl = $('[data-hero-current]', hero);
    const pauseBtn = $('.hero__pause', hero);
    const n = slides.length;
    if (window.matchMedia('(max-width: 900px)').matches) return;
    if (n < 2) { bars.forEach((b) => b.classList.add('is-done')); return; }
    const dur = parseInt(hero.dataset.duration || '6500', 10);
    hero.style.setProperty('--hero-dur', dur + 'ms');
    let i = 0, timer = null, paused = reduced, userPaused = reduced;

    const go = (to) => {
      if (to === i) return;
      const from = i;
      i = (to + n) % n;
      slides.forEach((s, k) => {
        s.classList.toggle('is-prev', k === from);
        s.classList.toggle('is-active', k === i);
        s.setAttribute('aria-hidden', k === i ? 'false' : 'true');
      });
      titles.forEach((t, k) => {
        t.classList.toggle('is-leaving', k === from);
        t.classList.toggle('is-active', k === i);
        t.setAttribute('aria-hidden', k === i ? 'false' : 'true');
      });
      setTimeout(() => titles[from] && titles[from].classList.remove('is-leaving'), 700);
      $$('.hero__eb', hero).forEach((s, k) => s.classList.toggle('is-active', k === i));
      subs.forEach((s, k) => {
        s.classList.toggle('is-active', k === i);
        s.toggleAttribute('inert', k !== i);
      });
      bars.forEach((b, k) => {
        b.classList.remove('is-active');
        b.classList.toggle('is-done', k < i);
        b.setAttribute('aria-current', k === i ? 'true' : 'false');
      });
      void bars[i].offsetWidth;
      bars[i].classList.add('is-active');
      if (countEl) countEl.textContent = String(i + 1).padStart(2, '0');
      schedule();
    };
    const schedule = () => { clearTimeout(timer); if (!paused) timer = setTimeout(() => go(i + 1), dur); };
    const setPaused = (p) => {
      paused = p;
      hero.classList.toggle('is-paused', p);
      if (pauseBtn) pauseBtn.setAttribute('aria-label', p ? 'הפעלת המצגת' : 'השהיית המצגת');
      if (p) clearTimeout(timer); else schedule();
    };

    bars.forEach((b, k) => b.addEventListener('click', () => go(k)));
    pauseBtn && pauseBtn.addEventListener('click', () => { userPaused = !paused; setPaused(!paused); });
    hero.addEventListener('focusin', () => setPaused(true));
    hero.addEventListener('focusout', (e) => { if (!hero.contains(e.relatedTarget) && !userPaused) setPaused(false); });
    document.addEventListener('visibilitychange', () => { if (!userPaused) setPaused(document.hidden); });
    hero.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') go(i + 1);
      if (e.key === 'ArrowRight') go(i - 1);
    });

    // swipe
    let sx = null, sy = null;
    const stage = $('.hero__stage', hero);
    stage.addEventListener('pointerdown', (e) => { sx = e.clientX; sy = e.clientY; }, { passive: true });
    stage.addEventListener('pointerup', (e) => {
      if (sx === null) return;
      const dx = e.clientX - sx, dy = e.clientY - sy;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) go(dx > 0 ? i + 1 : i - 1);
      sx = null;
    });

    // pause when off screen
    new IntersectionObserver(([en]) => { if (!userPaused) setPaused(!en.isIntersecting); }, { threshold: .2 }).observe(hero);

    bars[0].classList.add('is-active');
    hero.classList.toggle('is-paused', paused);
    schedule();
  })();

  /* ---------------- reveal on scroll ---------------- */
  (() => {
    const els = $$('[data-reveal]');
    if (!els.length) return;
    if (reduced || !('IntersectionObserver' in window)) { els.forEach((e) => e.classList.add('is-in')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: .08 });
    els.forEach((e) => io.observe(e));
  })();

  /* ---------------- parallax + scroll-lit statement ---------------- */
  (() => {
    if (reduced) return;
    const px = $$('[data-parallax]');
    const words = $$('.intro__statement .w');
    if (!px.length && !words.length) return;
    let ticking = false;
    const update = () => {
      const vh = window.innerHeight;
      px.forEach((el) => {
        const r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        const speed = parseFloat(el.dataset.parallax) || .12;
        const p = (r.top + r.height / 2 - vh / 2) / vh;
        el.style.transform = `translate3d(0, ${(p * speed * 100).toFixed(2)}%, 0)`;
      });
      if (words.length) {
        const box = words[0].parentElement.getBoundingClientRect();
        const prog = Math.min(1, Math.max(0, (vh * .85 - box.top) / (box.height + vh * .35)));
        const lit = Math.round(prog * words.length);
        words.forEach((w, k) => w.classList.toggle('is-lit', k < lit));
      }
      ticking = false;
    };
    window.addEventListener('scroll', () => { if (!ticking) { requestAnimationFrame(update); ticking = true; } }, { passive: true });
    window.addEventListener('resize', update);
    update();
  })();

  /* ---------------- shop by moment ---------------- */
  (() => {
    const root = $('[data-moments]');
    if (!root) return;
    const items = $$('.moment', root);
    const imgs = $$('.moments__img', root);
    const cap = $('[data-moment-caption]', root);
    const capLink = $('[data-moment-link]', root);
    const set = (k) => {
      items.forEach((it, j) => it.classList.toggle('is-active', j === k));
      imgs.forEach((im, j) => im.classList.toggle('is-active', j === k));
      if (cap) cap.textContent = items[k].dataset.caption || '';
      if (capLink) capLink.href = $('a', items[k]).href;
    };
    let cur = 0, hold = false, onScreen = false;
    items.forEach((it, k) => {
      it.addEventListener('mouseenter', () => { cur = k; set(k); });
      $('a', it).addEventListener('focus', () => { cur = k; set(k); });
    });
    // images rotate on their own until the visitor points at a concept
    const list = $('.moments__list', root);
    list && list.addEventListener('mouseenter', () => (hold = true));
    list && list.addEventListener('mouseleave', () => (hold = false));
    root.addEventListener('focusin', () => (hold = true));
    root.addEventListener('focusout', (e) => { if (!root.contains(e.relatedTarget)) hold = false; });
    const visibleNow = () => { const r = root.getBoundingClientRect(); return r.top < window.innerHeight * .7 && r.bottom > window.innerHeight * .3; };
    if (!reduced && items.length > 1) {
      setInterval(() => {
        onScreen = visibleNow();
        if (hold || !onScreen || document.hidden) return;
        cur = (cur + 1) % items.length;
        set(cur);
      }, 4200);
    }
    set(0);
  })();

  /* ---------------- craft scrollytelling ---------------- */
  (() => {
    const root = $('[data-craft]');
    if (!root) return;
    const steps = $$('.craft__step', root);
    const frames = $$('.craft__frame', root);
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (!en.isIntersecting) return;
        const k = steps.indexOf(en.target);
        steps.forEach((s, j) => s.classList.toggle('is-active', j === k));
        frames.forEach((f, j) => f.classList.toggle('is-active', j === k));
      });
    }, { rootMargin: '-45% 0px -45% 0px' });
    steps.forEach((s) => io.observe(s));
  })();

  /* ---------------- product sliders ---------------- */
  $$('[data-rail]').forEach((root) => {
    const track = $('[data-rail-track]', root);
    const prev = $('[data-rail-prev]', root);
    const next = $('[data-rail-next]', root);
    const bar = $('[data-rail-bar]', root);
    if (!track) return;
    const rtl = getComputedStyle(track).direction === 'rtl';
    const step = () => track.clientWidth * .98;
    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      const pos = Math.abs(track.scrollLeft);
      if (prev) prev.disabled = pos < 4;
      if (next) next.disabled = pos > max - 4;
      if (bar) {
        const w = max > 0 ? track.clientWidth / track.scrollWidth : 1;
        bar.style.setProperty('--w', (w * 100).toFixed(2) + '%');
        const travel = (1 - w) * (max > 0 ? pos / max : 0);
        bar.parentElement.style.setProperty('--x', '0');
        bar.style.transform = `translateX(${(rtl ? -1 : 1) * travel * bar.parentElement.clientWidth}px)`;
      }
    };
    prev && prev.addEventListener('click', () => { track.scrollBy({ left: (rtl ? 1 : -1) * step(), behavior: reduced ? 'auto' : 'smooth' }); setTimeout(update, 600); });
    next && next.addEventListener('click', () => { track.scrollBy({ left: (rtl ? -1 : 1) * step(), behavior: reduced ? 'auto' : 'smooth' }); setTimeout(update, 600); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', debounce(update, 150));
    update();
  });

  /* ---------------- marquee ---------------- */
  (() => {
    $$('[data-marquee]').forEach((m) => {
      const track = $('.marquee__track', m);
      const count = $$('.marquee__group:first-child li', m).length || 8;
      track.style.setProperty('--marquee-dur', Math.max(24, count * 4.5) + 's');
      const btn = $('[data-marquee-toggle]', m);
      btn && btn.addEventListener('click', () => {
        const p = m.classList.toggle('is-paused');
        btn.textContent = p ? 'המשך תנועה' : 'עצירת תנועה';
        btn.setAttribute('aria-pressed', String(p));
      });
    });
  })();

  /* ---------------- whatsapp ---------------- */
  (() => {
    const wa = $('.wa');
    if (!wa) return;
    const k = 'hl-wa-tip';
    let seen = false;
    try { seen = sessionStorage.getItem(k); } catch (e) {}
    if (seen) return;
    const t = setTimeout(() => {
      wa.classList.add('show-tip');
      try { sessionStorage.setItem(k, '1'); } catch (e) {}
      setTimeout(() => wa.classList.remove('show-tip'), 9000);
    }, 9000);
    $('.wa__tip button', wa)?.addEventListener('click', () => { clearTimeout(t); wa.classList.remove('show-tip'); });
  })();

  /* ================= CART ================= */
  const Cart = HL.Cart = {
    state: null,
    async req(url, body) {
      const opts = body
        ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }
        : { headers: { Accept: 'application/json' } };
      const res = await fetch(url, opts);
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.description || data.message || 'משהו השתבש. נסו שוב.');
      return data;
    },
    async get() { this.state = await this.req(HL.routes.cart + '.js'); render(); return this.state; },
    async add(items) {
      await this.req(HL.routes.cart_add + '.js', { items });
      await this.get();
    },
    async change(key, quantity) {
      this.state = await this.req(HL.routes.cart_change + '.js', { id: key, quantity });
      render();
    },
    async attrs(attributes) { this.state = await this.req(HL.routes.cart_update + '.js', { attributes }); },
    isGift(item) { return HL.giftWrap && String(item.variant_id) === String(HL.giftWrap.variantId); }
  };

  function render() {
    const c = Cart.state;
    if (!c) return;
    const drawer = $('#cart-drawer');
    const items = c.items.filter((it) => !Cart.isGift(it));
    const giftLine = c.items.find((it) => Cart.isGift(it));
    const count = items.reduce((n, it) => n + it.quantity, 0);

    $$('[data-cart-count]').forEach((el) => {
      const before = el.textContent;
      el.textContent = count;
      el.classList.toggle('has-items', count > 0);
      if (before !== String(count) && count > 0) { el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); }
    });
    $$('[data-cart-count-label]').forEach((el) => { el.textContent = count ? `סל קניות, ${count} פריטים` : 'סל קניות, ריק'; });
    if (!drawer) return;

    $('[data-cart-title-count]', drawer).textContent = count || '';
    const empty = $('[data-cart-empty]', drawer);
    const full = $('[data-cart-full]', drawer);
    empty.hidden = count > 0;
    full.hidden = count === 0;
    $$('[data-cart-foot]', drawer).forEach((f) => (f.hidden = count === 0));

    // free shipping progress (gift wrap does not count toward the threshold)
    const merch = items.reduce((s, it) => s + it.final_line_price, 0);
    const goal = HL.freeShipping;
    const ship = $('[data-ship]', drawer);
    if (ship && goal > 0) {
      const p = Math.min(1, merch / goal);
      ship.style.setProperty('--p', p.toFixed(3));
      ship.classList.toggle('is-free', p >= 1);
      $('[data-ship-msg]', ship).innerHTML = p >= 1
        ? 'המשלוח עלינו. <b>משלוח חינם</b> להזמנה הזו.'
        : `עוד <b>${money(goal - merch)}</b> ומשלוח עד הבית חינם.`;
      $('.ship__bar', ship).setAttribute('aria-valuenow', Math.round(p * 100));
    }

    // small items to reach free shipping: only when a little is missing, up to 3 not yet in the cart
    const upsell = $('[data-upsell]', drawer);
    if (upsell) {
      const missing = goal - merch;
      const show = goal > 0 && missing > 0 && missing <= parseInt(upsell.dataset.gap, 10);
      const inCart = new Set(c.items.map((it) => String(it.variant_id)));
      let shown = 0;
      $$('[data-upsell-item]', upsell).forEach((li) => {
        li.hidden = !show || inCart.has(li.dataset.upsellItem) || shown >= 3;
        if (!li.hidden) shown++;
      });
      upsell.hidden = shown === 0;
    }

    const list = $('[data-cart-items]', drawer);
    list.innerHTML = items.map((it) => {
      const variant = it.variant_title && it.variant_title !== 'Default Title' ? `<p class="line__variant">${esc(it.variant_title)}</p>` : '';
      const props = Object.entries(it.properties || {}).filter(([k, v]) => v && k[0] !== '_').map(([k, v]) => `<p class="line__variant">${esc(k)}: ${esc(v)}</p>`).join('');
      const was = it.original_line_price > it.final_line_price ? `<s class="t-muted" style="font-weight:400;margin-inline-end:.35rem">${money(it.original_line_price)}</s>` : '';
      return `<li class="line" data-key="${esc(it.key)}">
        <a class="line__img" href="${esc(it.url)}" tabindex="-1" aria-hidden="true">${it.image ? `<img src="${esc(imgUrl(it.image, 240))}" alt="" width="92" height="115" loading="lazy">` : ''}</a>
        <div>
          <div class="line__top">
            <div><a class="line__title" href="${esc(it.url)}">${esc(it.product_title)}</a>${variant}${props}</div>
            <p class="line__price price">${was}${money(it.final_line_price)}</p>
          </div>
          <div class="line__bottom">
            <div class="qty" role="group" aria-label="כמות עבור ${esc(it.product_title)}">
              <button type="button" data-qty="${it.quantity + 1}" aria-label="הוספת יחידה">${ICON.plus}</button>
              <input type="number" inputmode="numeric" min="0" value="${it.quantity}" aria-label="כמות" data-qty-input>
              <button type="button" data-qty="${it.quantity - 1}" aria-label="הסרת יחידה">${ICON.minus}</button>
            </div>
            <button type="button" class="line__remove" data-qty="0">הסרה</button>
          </div>
        </div>
      </li>`;
    }).join('');

    $('[data-cart-subtotal]', drawer).textContent = money(c.total_price);

    const greet = $('[data-greet]', drawer);
    if (greet) {
      const ta = $('textarea', greet);
      if (document.activeElement !== ta) ta.value = (c.attributes || {})[HL.greetKey] || '';
      $('[data-greet-count]', greet).textContent = `${ta.value.length}/150`;
    }
  }

  function cartError(msg) {
    const drawer = $('#cart-drawer');
    const box = drawer && $('[data-cart-error]', drawer);
    if (box) { box.textContent = msg; box.hidden = false; setTimeout(() => (box.hidden = true), 5000); }
    else toast(msg);
  }

  // quantity / remove
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('#cart-drawer [data-qty]');
    if (!b) return;
    const line = b.closest('.line');
    line.classList.add('is-removing');
    try { await Cart.change(line.dataset.key, Math.max(0, parseInt(b.dataset.qty, 10))); }
    catch (err) { line.classList.remove('is-removing'); cartError(err.message); }
  });
  document.addEventListener('change', async (e) => {
    const inp = e.target.closest('#cart-drawer [data-qty-input]');
    if (!inp) return;
    const line = inp.closest('.line');
    try { await Cart.change(line.dataset.key, Math.max(0, parseInt(inp.value, 10) || 0)); }
    catch (err) { cartError(err.message); Cart.get(); }
  });

  // character counters for short text fields (e.g. sticker text)
  document.addEventListener('input', (e) => {
    const inp = e.target.closest('[data-count-target]');
    if (!inp) return;
    const out = document.getElementById(inp.dataset.countTarget);
    if (out) out.textContent = `${inp.value.length}/${inp.maxLength}`;
  });
  // personal greeting for the card (cart attribute, shows on the order)
  (() => {
    const greet = $('#cart-drawer [data-greet]');
    if (!greet) return;
    const ta = $('textarea', greet);
    const saved = $('[data-greet-saved]', greet);
    const count = $('[data-greet-count]', greet);
    const save = debounce(async () => {
      try { await Cart.attrs({ [HL.greetKey]: ta.value.trim() }); saved.textContent = 'הברכה נשמרה'; setTimeout(() => (saved.textContent = ''), 2200); }
      catch (err) { saved.textContent = 'לא הצלחנו לשמור את הברכה. נסו שוב.'; }
    }, 700);
    ta.addEventListener('input', () => { count.textContent = `${ta.value.length}/150`; saved.textContent = ''; save(); });
  })();

  // add to cart: product forms and quick-add buttons
  const swatchMissing = (form) => $$('[data-swatches]', form).find((g) => !$('input:checked', g));
  async function addFromForm(form, btn) {
    const fd = new FormData(form);
    const id = fd.get('id');
    const quantity = parseInt(fd.get('quantity') || '1', 10);
    const properties = {};
    for (const [k, v] of fd.entries()) { const m = k.match(/^properties\[(.+)\]$/); if (m && v) properties[m[1]] = v; }
    // ticked add-ons (e.g. the Hanukkah blessing) go in as their own line, one of each
    const addons = $$('input[data-addon]:checked', form).map((el) => ({ id: el.dataset.addon, quantity: 1 }));
    btn && btn.classList.add('is-loading');
    try {
      await Cart.add([{ id, quantity, properties }, ...addons]);
      addons.length && $$('input[data-addon]', form).forEach((el) => (el.checked = false));
      open('cart-drawer');
    } catch (err) { toast(err.message); }
    btn && btn.classList.remove('is-loading');
  }
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    // a required colour that was not chosen yet
    const noColour = swatchMissing(form);
    if (noColour) {
      noColour.classList.add('is-error');
      noColour.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
      $('input', noColour).focus({ preventScroll: true });
      toast('נא לבחור צבע');
      return;
    }
    // required fields that are open (e.g. the text for an added container) must be filled first
    const missing = $$('input[required]:not([disabled]), select[required]:not([disabled])', form).find((el) => !el.value.trim());
    if (missing) {
      const f = missing.closest('.field');
      f && f.classList.add('is-error');
      missing.focus();
      missing.addEventListener('input', () => f && f.classList.remove('is-error'), { once: true });
      missing.addEventListener('change', () => f && f.classList.remove('is-error'), { once: true });
      toast(missing.tagName === 'SELECT' ? 'נא לבחור אפשרות' : 'נא למלא מה לכתוב');
      return;
    }
    addFromForm(form, $('[type="submit"]', form) || e.submitter);
  });
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-quick-add]');
    if (!b) return;
    e.preventDefault();
    b.classList.add('is-loading');
    try { await Cart.add([{ id: b.dataset.quickAdd, quantity: 1 }]); open('cart-drawer'); }
    catch (err) { toast(err.message); }
    b.classList.remove('is-loading');
  });

  if ($('#cart-drawer')) Cart.get().catch(() => {});
  // keep drawer in sync if another tab changes the cart
  window.addEventListener('pageshow', (e) => { if (e.persisted) Cart.get().catch(() => {}); });

  /* ================= PRODUCT ================= */
  (() => {
    const root = $('[data-pdp]');
    if (!root) return;
    const json = $('[data-product-json]', root);
    const product = json ? JSON.parse(json.textContent) : null;
    const form = $('form[data-product-form]', root);
    const idInput = form && $('input[name="id"]', form);
    const priceEl = $('[data-price]', root);
    const compareEl = $('[data-compare]', root);
    const saveEl = $('[data-save]', root);
    const btn = form && $('[type="submit"]', form);
    const btnLabel = btn && $('span', btn);
    const stock = $('[data-stock]', root);
    const stickyPrice = $('[data-sticky-price]');

    const current = () => {
      const chosen = $$('.opt', root).map((fs) => ($('input:checked', fs) || {}).value);
      return product.variants.find((v) => v.options.every((o, k) => o === chosen[k]));
    };
    const markAvailability = () => {
      $$('.opt', root).forEach((fs, idx) => {
        $$('input', fs).forEach((inp) => {
          const others = $$('.opt', root).map((f) => ($('input:checked', f) || {}).value);
          others[idx] = inp.value;
          const v = product.variants.find((vv) => vv.options.every((o, k) => o === others[k]));
          inp.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    };
    const update = () => {
      const v = current();
      if (!v) { btn.disabled = true; btnLabel.textContent = 'השילוב הזה לא זמין'; return; }
      idInput.value = v.id;
      priceEl.textContent = money(v.price);
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      const sale = v.compare_at_price && v.compare_at_price > v.price;
      compareEl.hidden = !sale; saveEl.hidden = !sale;
      if (sale) { compareEl.textContent = money(v.compare_at_price); saveEl.textContent = `חיסכון ${Math.round((1 - v.price / v.compare_at_price) * 100)}%`; }
      btn.disabled = !v.available;
      btnLabel.textContent = v.available ? btn.dataset.label : 'אזל מהמלאי';
      if (stock) {
        stock.classList.toggle('is-out', !v.available);
        stock.textContent = v.available ? (stock.dataset.inText || 'במלאי') : (stock.dataset.outText || 'אזל מהמלאי כרגע');
      }
      const notify = $('[data-notify]', root);
      if (notify) notify.hidden = v.available;
      const stickyBtn = $('.sticky-buy button span');
      if (stickyBtn) stickyBtn.textContent = v.available ? 'הוספה לסל' : 'עדכנו אותי';
      if (v.featured_media && window.matchMedia('(max-width: 900px)').matches) {
        const m = $(`[data-media-id="${v.featured_media.id}"]`, root);
        m && m.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
      }
      const url = new URL(location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url);
      markAvailability();
      // text fields that belong to an add-on (e.g. "מיכל נוסף") open only when it is chosen
      $$('[data-show-when]', root).forEach((f) => {
        const on = v.options.some((o) => o.includes(f.dataset.showWhen));
        const inp = $('input, textarea', f);
        f.hidden = !on;
        if (inp) { inp.disabled = !on; inp.required = on; }
        if (on && inp && !reduced) f.animate([{ opacity: 0, transform: 'translateY(-6px)' }, { opacity: 1, transform: 'none' }], { duration: 320, easing: 'cubic-bezier(.16,1,.3,1)' });
      });
    };
    if (product && product.variants.length > 1) {
      root.addEventListener('change', (e) => { if (e.target.closest('.opt')) update(); });
      markAvailability();
    }

    // colour circles: show the chosen name, and bring the photo of that colour to the front
    const firstPic = $('.pdp__gallery .media', root);
    $$('[data-swatches]', root).forEach((g) => g.addEventListener('change', (e) => {
      const name = e.target.value;
      g.classList.remove('is-error');
      const out = $('[data-swatch-name]', g);
      if (out) out.textContent = name;
      const gal = $('.pdp__gallery', root);
      if (!gal) return;
      // a colour without its own photo (e.g. the original one) brings back the original first photo
      const pic = $$('[data-alt]', gal).find((m) => m.dataset.alt.includes(name)) || firstPic;
      if (!pic) return;
      if (pic !== gal.firstElementChild) {
        const img = $('img', pic);
        if (img) { img.loading = 'eager'; img.sizes = '(min-width: 900px) 55vw, 100vw'; }
        gal.prepend(pic);
      }
      if (window.matchMedia('(max-width: 900px)').matches) gal.scrollTo({ left: 0, behavior: reduced ? 'auto' : 'smooth' });
      else if (gal.getBoundingClientRect().top < 0) gal.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
    }));

    // quantity stepper on PDP
    $$('[data-step]', root).forEach((b) => b.addEventListener('click', () => {
      const inp = $('input[name="quantity"]', form);
      inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(b.dataset.step, 10));
    }));

    // gallery dots (mobile) + lightbox
    const gal = $('.pdp__gallery', root);
    const dots = $$('.pdp__dots i', root);
    if (gal && dots.length) {
      gal.addEventListener('scroll', debounce(() => {
        const k = Math.round(Math.abs(gal.scrollLeft) / gal.clientWidth);
        dots.forEach((d, j) => d.classList.toggle('is-active', j === k));
      }, 60), { passive: true });
    }
    const lb = $('.lightbox');
    if (gal && lb) {
      gal.addEventListener('click', (e) => {
        const m = e.target.closest('.media');
        if (!m || window.matchMedia('(max-width: 900px)').matches) return;
        const img = $('img', m);
        $('img', lb).src = img.dataset.zoom || img.currentSrc || img.src;
        $('img', lb).alt = img.alt;
        open('lightbox');
      });
    }

    // sticky buy bar on mobile
    const sticky = $('.sticky-buy');
    if (sticky && btn) {
      // visible whenever the main button is off screen (above or below), so buying is always one tap away
      new IntersectionObserver(([en]) => sticky.classList.toggle('is-on', !en.isIntersecting)).observe(btn);
      $('button', sticky).addEventListener('click', () => {
        // sold out: take the buyer to the "let me know" email field instead of the cart
        const notify = $('[data-notify]', root);
        if (btn.disabled && notify && !notify.hidden) {
          const em = $('input[type="email"]', notify);
          notify.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
          em && em.focus({ preventScroll: true });
          return;
        }
        // a required choice (e.g. scent) that is still empty: take the buyer to it instead of failing
        if (swatchMissing(form)) { form.requestSubmit ? form.requestSubmit() : form.submit(); return; }
        const missing = [...form.querySelectorAll('[required]')].find((f) => !f.value);
        if (missing) { missing.scrollIntoView({ behavior: 'smooth', block: 'center' }); missing.focus({ preventScroll: true }); return; }
        form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    }
  })();

  /* ================= PREDICTIVE SEARCH ================= */
  (() => {
    const root = $('#search-modal');
    if (!root) return;
    const input = $('input[type="search"]', root);
    const out = $('[data-search-results]', root);
    let ctrl;
    const run = debounce(async () => {
      const q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      ctrl && ctrl.abort();
      ctrl = new AbortController();
      try {
        const res = await fetch(`${HL.routes.predictive}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=4`, { signal: ctrl.signal });
        const data = await res.json();
        const ps = (data.resources && data.resources.results && data.resources.results.products) || [];
        out.innerHTML = ps.length
          ? `<ul class="p-grid" role="list">${ps.map((p) => `<li class="card">
              <div class="card__media">${p.image ? `<img src="${esc(imgUrl(p.image, 500))}" alt="${esc(p.title)}" loading="lazy" width="500" height="625">` : ''}</div>
              <div class="card__info"><h3 class="card__title"><a href="${esc(p.url)}">${esc(p.title)}</a></h3><p class="card__price price">${esc(money(Math.round(parseFloat(p.price) * 100)))}</p></div>
            </li>`).join('')}</ul>
            <p class="search__hint"><a href="${HL.routes.search}?q=${encodeURIComponent(q)}&type=product">לכל התוצאות עבור "${esc(q)}"</a></p>`
          : `<p class="search__hint">לא מצאנו מוצרים עבור "${esc(q)}". נסו מילה אחרת, למשל "נר" או "מזוזה".</p>`;
      } catch (err) { if (err.name !== 'AbortError') out.innerHTML = ''; }
    }, 220);
    input.addEventListener('input', run);
  })();

  /* ================= COLLECTION ================= */
  (() => {
    const sort = $('[data-sort]');
    sort && sort.addEventListener('change', () => {
      const url = new URL(location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      location.href = url.toString();
    });
    const filt = $('[data-filters]');
    filt && filt.addEventListener('change', debounce(() => filt.requestSubmit ? filt.requestSubmit() : filt.submit(), 450));
  })();
})();
